<template>
    <div>
      <div>
          <section v-if="!initialLoading">
          <div class="row">
              <div class="col-12">
                <div class="table-responsive">
                    <table
                    id="data-table-list-courses"
                    class="table-hover-animation table-striped table-bordered"
                    >
                      <thead>
                          <tr>
                            <th>Imagen</th>
                            <th>Nombre</th>
                            <th>Descripción</th>
                            <th>Fecha</th>
                            <th>Estado</th>
                            <th>Acción</th>
                          </tr>
                      </thead>
                      <tbody>
                          <tr v-for="event in events" :key="event.id">
                            <td>
                              <img :src="event.path" class="img-thumbnail">
                            </td>
                            <td>{{event.name}}</td>
                            <td>{{event.description}}</td>
                            <td>{{ moment(event.updated_at).format('DD/MM/YYYY hh:mm A')}}</td>
                            <td>
                                <el-tag
                                    :type="event.status == 0 ? 'danger' : 'success'"
                                    class="mx-1"
                                    effect="dark"
                                >
                                    {{ event.status == 0 ? 'No publicado' : 'Publicado' }}
                                </el-tag>
                            </td>
                            
                            <td>
                                <select @change="getOptionSelected(event, $event)" v-model="optionSelected">
                                    <option value="" disabled selected>Seleccione una acción</option>
                                    <option v-for="item in options" :value="item.value">{{item.label}}</option>
                                </select>
                            </td>
                        </tr>
                      </tbody>
                    </table>
                </div>
              </div>
          </div>
          </section>
          <custom-spinner v-else></custom-spinner>

          <custom-modal id="edit-event-modal" color="primary" size="large" v-if="eventSelected">
            <template #title
            >Editar event <u> {{ eventSelected.name }} </u></template
            >
            <template #body>
            <form-event-edit
                :event="eventSelected"
            ></form-event-edit>
            </template>
          </custom-modal>
      </div>
    </div>
  </template>
  <script>
  import moment from 'moment';
  import ModalComponent from '../ModalComponent.vue';
  import eventEdit from './edit.vue';
  import CustomSpinner from '../../common/custom-spinner/CustomSpinner.vue';
  import language from '../../api/traduction_es';
  
  export default {
    data() {
      return {
        initialLoading: false,
        moment: moment,
        events: [],
        eventSelected: [],
        options: [
          {
            value: '1',
            label: 'Editar',
          },
          {
            value: '2',
            label: 'Publicar/Ocultar',
          },
        ],
        optionSelected: '',
      };
    },
    components: {
      'custom-modal': ModalComponent,
      'custom-spinner': CustomSpinner,
      'form-event-edit': eventEdit,
    },
  
    mounted() {
      this.listarEvents();
      console.log(this.events)
    },
  
    methods: {
      loadDataTable() {
        $(document).ready( function () {
            $('#data-table-list-courses').DataTable(language);
        });
      },
      listarEvents: function () {
        this.initialLoading = true;
        axios.get(`/events/list`).then((response) => {
          console.log(response);
          this.events = response.data;
          this.initialLoading = false;
          this.loadDataTable();
        });
      },
      async changeStatus(event){
        await axios.patch(`/events/change-status/${event.id}`).then((response) => {
          this.$message.success(response.data);
          this.listarEvents();
        });
      },
      getOptionSelected(event) {
        // La opcion se recupera de la variable optionSelected
        let option = this.optionSelected;
        switch (option) {
          case '1':
            this.eventSelected = event;
            $('#edit-event-modal').modal('show');
            this.optionSelected = '';
            break;
          case '2':
            this.changeStatus(event);
            this.optionSelected = '';
            break;
          // case '3':
          //   this.courseSelected = course;
          //   $('#edit-course-modal').modal('show');
          //   this.optionSelected = '';
          //   break;
          default:
            console.log('Error');
            break;
        }
        // document.getElementById("select").value = "Seleccione";
      },
    },
  };
  </script>
  <style>
  .el-select {
    width: 80%;
  }
  .el-select .el-input .el-select__caret::before {
    content: '\e794';
  }
  
  #customize_select {
    background-color: #ffffff !important;
    border: none !important;
    width: 0px !important;
    font-size: 0px !important;
    justify-content: center;
    text-align: center;
    padding: 0 !important;
  }
  </style>
  